__turbopack_context__.v({
  "badge": "AvatarFreshnessBadge-module__2XGW0q__badge",
  "clickable": "AvatarFreshnessBadge-module__2XGW0q__clickable",
  "fresh": "AvatarFreshnessBadge-module__2XGW0q__fresh",
  "stale": "AvatarFreshnessBadge-module__2XGW0q__stale",
  "tooltipFresh": "AvatarFreshnessBadge-module__2XGW0q__tooltipFresh",
  "tooltipStale": "AvatarFreshnessBadge-module__2XGW0q__tooltipStale",
});
